import React from 'react';

import styled from 'styled-components';

import { colors } from 'z-react-components';

const Container = styled.div`
    padding: 32px 0;
`;

const Title = styled.h2`
    text-align: center;
    font-weight: bold;
    margin: 0 0 16px 0;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`;

const VideoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    background-image: url('/_assets/images/landingV2/video_background.svg');
    background-position: center;
    background-repeat: no-repeat;
`;

const VideoWrapper = styled.div`
    background-color: ${colors.white};
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.36);
    border-radius: 12px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const VideoHeader = styled.div`
    border-radius: 12px 12px 0px 0px;
    width: 100%;
    background-color: #e8eaed;
    overflow: hidden;
`;

const YoutubeVideoWrapper = styled.div`
    padding: 16px;
    border-radius: 0px 0px 12px 12px;
    border-top: 0px;
    overflow: hidden;
`;

const YoutubeVideo = styled.iframe`
    height: 315px;
    width: 576px;
    border: none;

    @media (max-width: 670px) {
        height: 165px;
        width: 270px;
    }
`;

const Video = () => (
    <Container>
        <Title>{'Scopri di più, guarda il video'}</Title>
        <VideoContainer>
            <VideoWrapper>
                <VideoHeader>
                    <img src="/_assets/images/landingV2/browser_header.svg" style={{ height: '100%', width: '100%' }} alt="" />
                </VideoHeader>
                <YoutubeVideoWrapper>
                    <YoutubeVideo
                        src="https://www.youtube-nocookie.com/embed/GowPDEJ7qAE"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen={true}
                    />
                </YoutubeVideoWrapper>
            </VideoWrapper>
        </VideoContainer>
    </Container>
);

export default Video;
